import axios from '../../axios'

/*
 * 考区数据接口
 */

// 获取考区列表
export const getAreaList = (data) => {
    return axios({
        url: '/api/mock/base/area',
        method: 'get',
        data
    })
}

// 新增考区信息
export const saveArea = (data) => {
    return axios({
        url: '/api/mock/base/area',
        method: 'post',
        data
    })
}

// 编辑考区信息
export const updateArea = (data) => {
    return axios({
        url: '/api/mock/base/area',
        method: 'put',
        data
    })
}

// 删除考区列表
export const deleteArea = (data) => {
    return axios({
        url: '/api/mock/base/area',
        method: 'delete',
        data
    })
}

export const upload = (data) => {
    return axios({
        url: '/common/image/upload',
        method: 'post',
        data
    })
}

export const fileUpload = (data) => {
    return axios({
        url: '/common/file/upload',
        method: 'post',
        data
    })
}

// 导出机构信息
export const exportArea = (data) => {
    return axios({
        url: '/api/mock/base/area/export',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/base/area.js